const contentManagement = {
  title: '配置中心',
  desc: '统一管理内容模板与邮箱配置，集中维护发送与沟通相关设置。',
  moduleLabel: '配置',
  contentModuleLabel: '内容模板',
  accountModuleLabel: '账户',
  descChat: '该常用语用于Linkedin Messaging对话框中的模板 - 提升沟通效率',
  descGreeting: '该添加好友留言用于 EasyHire AI 后台添加好友时的模板 - 提升沟通效率',
  descInmail: '该 InMail 模板用于 LinkedIn 站内信触达场景 - 提升企业版批量沟通效率',
  descTemplate: '该邮件模板用于EasyHire AI后台发送邮件时的模板 - 提升沟通效率',
  tabChat: '常用语',
  tabGreeting: '添加好友留言',
  tabInmail: 'InMail模板',
  tabTemplate: '邮件模板',
  chat: '即时聊天',
  greeting: '添加好友留言',
  inmail: 'InMail模板',
  template: '邮件模板',
  editPhrase: '编辑常用语',
  editPhraseDesc: '在这里直接修改{type}内容，保存后会立即更新列表。',
  editingBadge: '编辑中',
  addPhrase: '添加',
  addPhraseTitle: '添加常用语',
  addGreetingPhraseTitle: '添加好友留言',
  addInmailPhraseTitle: '添加 InMail 模板',
  addPhraseDesc: '新增后会立即出现在列表中，后续也可以随时编辑或删除。',
  phraseTitle: '备注',
  phraseTitlePlaceholder: '请输入备注',
  phraseContent: '内容',
  phraseContentPlaceholder: '请输入内容',
  phraseCount: '共 {count} 条',
  refresh: '刷新',
  phraseLabel: '备注：',
  contentLabel: '内容：',
  unnamedTitle: '未填写备注',
  edit: '编辑',
  delete: '删除',
  loadingTitle: '正在加载{type}',
  templateLoadingTitle: '正在加载邮件模板',
  loadingDesc: '请稍候，内容马上就到。',
  emptyTitle: '还没有{type}',
  emptyDesc: '先参考下面的模板，点击右上角添加按钮后就能开始自定义。',
  emptyExampleBadge: '参考模板',
  sceneButton: '使用示例',
  sceneBadge: '使用场景',
  chatSceneTitle: 'LinkedIn Messaging 对话框使用场景',
  chatSceneDesc: '该常用语会出现在 LinkedIn Messaging 对话框中，使用入口：',
  greetingSceneTitle: '添加好友弹窗使用场景',
  greetingSceneDesc: '该打招呼语会出现在添加好友弹窗的“使用模板”入口中。',
  emptyChatNotePrimary: '破冰开场',
  emptyChatContentPrimary: "Hi {'{name}'}，很想和你简单聊聊团队目前在做的方向。",
  emptyChatNoteSecondary: '继续跟进',
  emptyChatContentSecondary:
    '想继续确认一下你这周是否方便抽 10 分钟了解一下机会，如果合适我可以把 JD 发你。',
  emptyGreetingNotePrimary: '简洁邀请',
  emptyGreetingContentPrimary:
    "Hi {'{name}'}，关注到你的经历和我们正在招聘的岗位很匹配，想先加你简单聊聊。",
  emptyGreetingNoteSecondary: '行业同频',
  emptyGreetingContentSecondary: "你好 {'{name}'}，你的职业背景很有代表性，方便先认识一下吗？",
  emptyInmailNotePrimary: '岗位邀约',
  emptyInmailContentPrimary:
    "Hi {'{{name}}'}，看到你在 {'{{company}}'} 的经历很匹配，我们正在招聘 {'{{role}}'}，想和你简单介绍一下机会。",
  emptyInmailNoteSecondary: '高潜候选人',
  emptyInmailContentSecondary:
    "你好 {'{{name}}'}，你的 {'{{industry}}'} 背景很符合我们关注的方向，如果你愿意，我可以发你岗位详情。",
  emptyTemplateDesc: '先参考这份邮件模板结构，点击右上角新建模板后就可以替换成你自己的版本。',
  emptyTemplateName: '岗位邀约模板',
  emptyTemplateSubject: "A quick intro about an opportunity at {'{{company}}'}",
  emptyTemplateSnippet:
    "Hi {'{{name}}'}，\n\n看到你在 {'{{company}}'} 的背景后，我觉得你和我们正在招聘的 {'{{role}}'} 很匹配。\n\n如果你这周方便，我想约你简单聊 10 分钟，也可以先把 JD 发给你参考。\n\nBest regards,\n{'{{name}}'}",
  emptyTemplateFooter: '创建后这里会展示你的最新模板',
  templateList: '模板列表',
  newTemplate: '新建模板',
  noTemplate: '暂无邮件模板',
  templateName: '模板名称',
  templateNamePlaceholder: '例如：岗位邀约模板',
  emailSubject: '邮件标题',
  emailSubjectPlaceholder: '请输入邮件标题',
  htmlBody: 'HTML 正文',
  templateEditorDesc: '接口仅需要模板名称、邮件标题和 HTML 正文，保存后可直接用于发信。',
  templateChannel: 'Email',
  updatedAt: '更新于',
  deleteCurrentTemplate: '删除当前模板',
  cancel: '取消',
  emailPreview: '邮件预览',
  placeholderLabel: '占位符:',
  placeholderExample: "eg：你好{'{{name}}'} = 你好 Clement Hu",
  updateTemplate: '更新模板',
  saveTemplate: '保存模板',
  previewTitle: '邮件预览',
  noSubject: '未填写标题',
  noContent: '暂无内容',
  titleRequired: '备注不能为空',
  contentRequired: '内容不能为空',
  contentTooLong: '内容不能超过 {count} 字',
  loadFailed: '加载失败',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  deleteConfirm: '删除后不可恢复，确认继续吗？',
  deletePhraseTitle: '删除常用语',
  deleted: '已删除',
  deleteFailed: '删除失败',
  templateFieldsRequired: '模板名称、标题和正文不能为空',
  templateUpdateSuccess: '模板更新成功',
  templateCreateSuccess: '模板创建成功',
  deleteTemplateConfirm: '删除模板后不可恢复，确认继续吗？',
  deleteTemplateTitle: '删除邮件模板',
  templateDeleted: '邮件模板已删除',
}

export default contentManagement
